import script from "./PendingTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingTasks.vue?vue&type=script&setup=true&lang=js"

import "./PendingTasks.vue?vue&type=style&index=0&id=16fdcc49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fdcc49"]])

export default __exports__